module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<fieldset><h5 class="icon-header">'+
((__t=( i18n.tc("Recipients", "Add a new Recipient") ))==null?'':__t)+
'</h5><div><label for="recipient-name">'+
((__t=( i18n.tc("Recipients", "Name:") ))==null?'':__t)+
'</label> <input maxlength="50" id="recipient-name" type="text" data-input="recipient-name" required></div></fieldset><fieldset class="button-wrap"><button class="jegigjiesjg" data-click="recipient-cancel">'+
((__t=( i18n.tc("Recipients", "Cancel") ))==null?'':__t)+
'</button> <button type="submit" data-click="recipient-submit" class="primary" disabled="disabled">'+
((__t=( i18n.tc("Recipients", "Save") ))==null?'':__t)+
'</button></fieldset>';
}
return __p;
};
